import React from "react";
import Panel from "muicss/lib/react/panel";
import axios from "axios";
import { totalCoins } from "../../common/lumens.js";
import { totalFeePool } from "../../common/lumens.js";

export class LastDistribution extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Panel>
        <h3>{this.props.dictionary["lastDistribution"][this.props.lang]}</h3>
        <h5>
          {this.props.dictionary["date"][this.props.lang]} : <span>-</span>
        </h5>
        <h5>
          {this.props.dictionary["totalPaid"][this.props.lang]} : <span>-</span>
        </h5>
        <h5>
          {this.props.dictionary["transferToNextMonth"][this.props.lang]} :{" "}
          <span>-</span>
        </h5>
      </Panel>
    );
  }
}

export class CurrentInflation extends React.Component {
  constructor(props) {
    super(props);
    this.state = { totalFeePool: 0, MonthlyInflation: 0 };
  }

  componentDidMount() {
    totalFeePool(this.props.horizonURL).then((amount) => {
      this.setState({ totalFeePool: amount });
    });

    Promise.all([
      totalCoins(this.props.horizonURL),
      totalFeePool(this.props.horizonURL),
    ]).then((data) => {
      var amount = (0.12 * parseInt(data[0]) + parseInt(data[1])) / 12;
      this.setState({ MonthlyInflation: parseInt(amount) });
    });
  }

  render() {
    return (
      <Panel>
        <h3>{this.props.dictionary["currentInflation"][this.props.lang]}</h3>
        <h5>
          {this.props.dictionary["remainingTime"][this.props.lang]} :{" "}
          <span>-</span>
        </h5>
        <h5>
          {this.props.dictionary["monthlyInflation"][this.props.lang]} :{" "}
          <span>{this.state.MonthlyInflation.toLocaleString()}</span>
        </h5>
        <h5>
          {this.props.dictionary["feePool"][this.props.lang]} :{" "}
          <span>{this.state.totalFeePool.toLocaleString()}</span>
        </h5>
        <h5>
          {this.props.dictionary["lastMonthTransfer"][this.props.lang]} :{" "}
          <span>-</span>
        </h5>
        <h5>
          {this.props.dictionary["totalInflation"][this.props.lang]} :{" "}
          <span>-</span>
        </h5>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/components/InflationWidgets.js